//import { Accordion } from "src/lib";
import { Divider, Grid } from "src/lib";
import { IRootProps } from "./types";

const Root = (props: IRootProps) => {
    return (
        <>
            <Grid sx={props.sx}>
                {props.children}
            </Grid>
            <Divider color="secondary" sx={{ mt: 4 }} />
        </>
    );
};

export { Root };
